import { CheckHotelIntegrationCode, CheckHotelPmsCode, CheckRegimenIntegrationCode, createHotelsConfig, editHotelsConfig, fetchHotelsRegimens, fetchHotelsRooms, getAllServices } from "../../../../../../../api/repositoryEP";
import { Category, HotelRegimesData, HotelRoomsData, HotelsConfigCreateData, HotelsConfigData, HotelsConfigEditData, RoomConfigCreateData, ServiceDto, TranslationData } from "../../../../../../../models/MappingData";
import { useEffect, useState } from "react";
import { Form, Row, Col, Button, Switch, Select, InputNumber, Divider, Tabs, TabsProps, Alert } from "antd";
import { Input, Checkbox } from "antd";
import { useTranslation } from "react-i18next";
import './HotelsForm.scss';
import { GetKeyIcon, GetStarIcon } from "../../../../../../../utils/icons";
import { LoadingData } from "../../../../../../common";
import IconSelectorMultiple from "../../../../../../IconsMaterialSymbol/IconSelectorMultiple";
import { MaterialSymbol, MaterialSymbolProps } from "react-material-symbols";
import { useAppConfig } from "../../../../../../../Contexts/AppConfigContext";
import { set } from "lodash";

interface HotelFormProps {
    drawerVisible: boolean;
    setDrawerVisible: (visible: boolean) => void;
    hotelData: HotelsConfigData | null;
    setHotelData: (hotelData: HotelsConfigData | null) => void;
    isForcingCache: boolean;
    availableWALanguages: string[];
    onForceRefreshCache: (hotelIntegrationIds: string[], language: string) => void;
    language: string;
    servicesAvailable: ServiceDto[];
}

const HotelForm = (props: HotelFormProps): JSX.Element => {
    const [loading, setLoading] = useState<boolean>(true);
    const [loadingSaveButton, setLoadingSaveButton] = useState<boolean>(false);
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [regimens, setRegimens] = useState<Array<HotelRegimesData>>([]);
    const [rooms, setRooms] = useState<Array<HotelRoomsData>>([]);
    const numberCategory = [1, 2, 3, 4, 5];
    const typeCategory = [
        { key: 'key', icon: GetKeyIcon("app-icon width-12px") },
        { key: 'star', icon: GetStarIcon("app-icon width-12px") },
    ];

    useEffect(() => {console.log("Services available updated: ", props.servicesAvailable)},[props.servicesAvailable])

    const [selectedServiceIds, setSelectedServiceIds] = useState<string[]>([]);


    const [servicesAvailable, setServicesAvailable] = useState<ServiceDto[]>(props.servicesAvailable);



    const [hotelIntegrationCode, setHotelIntegrationCode] = useState<string>("");
    const [locationIntegrationCode, setLocationIntegrationCode] = useState<string>("");

    const optionsSelector = servicesAvailable
        .filter(s => s.icon)
        .map(s => {
            const normalizedLanguage = props.language.slice(0, 2).toLowerCase();
            const translatedName =
                s.name.find(n => n.language.slice(0, 2).toLowerCase() === normalizedLanguage)?.value ||
                s.name[0]?.value ||
                "No name available";

            return {
                label: (
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <MaterialSymbol
                            icon={s.icon as MaterialSymbolProps["icon"]}
                            size={20}
                        />
                        <span>{translatedName}</span>
                    </div>
                ),
                value: s.id,  //  el value es el ID
            };
        });


    const sortByName = <T extends { name: string }>(list: T[]) =>
        [...list].sort((a, b) => a.name.localeCompare(b.name, 'es', { sensitivity: 'base' }));

    const [roomSearch, setRoomSearch] = useState('');
    const [regimenSearch, setRegimenSearch] = useState('');
    const filteredRooms = sortByName(rooms).filter(room =>
        room.name.toLowerCase().includes(roomSearch.toLowerCase())
    );
    const filteredRegimens = sortByName(regimens).filter(regimen =>
        regimen.name.toLowerCase().includes(regimenSearch.toLowerCase())
    );



    useEffect(() => {
        if (props.hotelData) {
            setHotelIntegrationCode(props.hotelData.integrationCode ?? "");
            setLocationIntegrationCode(props.hotelData.locationIntegrationCode ?? "");
            form.setFieldsValue({
                name: props.hotelData.name,
                code: props.hotelData.code,
                integrationCode: props.hotelData.integrationCode,
                longitude: props.hotelData.longitude,
                latitude: props.hotelData.latitude,
                locationCode: props.hotelData.locationCode,
                locationIntegrationCode: props.hotelData.locationIntegrationCode,
                countryCode: props.hotelData.countryCode,
                countryName: props.hotelData.countryName,
                destination: props.hotelData.destination,
                numRooms: props.hotelData.numberRooms,
                hotelPaxConfiguration: props.hotelData.hotelPaxConfiguration,
                active: props.hotelData.active,
                numberCategory: props.hotelData.category.number,
                typeCategory: props.hotelData.category.type,
                sync: props.hotelData.syncReward,
                tax: props.hotelData.tax,
                minageinfant: props.hotelData.hotelPaxConfiguration?.minAgeInfant,
                maxageinfant: props.hotelData.hotelPaxConfiguration?.maxAgeInfant,
                minagechild: props.hotelData.hotelPaxConfiguration?.minAgeChild,
                maxagechild: props.hotelData.hotelPaxConfiguration?.maxAgeChild,
                minageteenager: props.hotelData.hotelPaxConfiguration?.minAgeTeenager,
                maxageteenager: props.hotelData.hotelPaxConfiguration?.maxAgeTeenager,
                //        rooms: props.hotelData.rooms.map(x => x.id),
                //      regimes: props.hotelData.regimen.map(x => x.id)
            });

        }
        setSelectedServiceIds(props.hotelData?.services?.map(s => s.id) || []);

    }, [props.hotelData, form]);

    useEffect(() => {
        const fetchHotelRoomData = async (id: string) => {
            const roomsResponse = await fetchHotelsRooms(props.language, id);
            if (roomsResponse?.type === 1) {
                setRooms(roomsResponse.data.data as Array<HotelRoomsData>);
            } else {
                props.setDrawerVisible(false);
            }

        };

        const fetchRegimenRoomData = async (id: string) => {

            const regimensResponse = await fetchHotelsRegimens(props.language, id);
            if (regimensResponse?.type === 1) {
                setRegimens(regimensResponse.data.data as Array<HotelRegimesData>);
            } else {
                props.setDrawerVisible(false);
            }

        };

        if (props.drawerVisible) {
            setLoading(true);
            const id = props.hotelData?.id ? props.hotelData.id : '';
            Promise.all([fetchHotelRoomData(id), fetchRegimenRoomData(id)])
                .then(() => {
                    setLoading(false);
                })
                .catch(() => {
                    setLoading(false);
                });
        }
    }, [props.drawerVisible]);

    const handleRoomsCheckboxChange = (roomId: string, active: any) => {
        const updatedRooms = rooms.map(room => {
            if (room.id === roomId) {
                return { ...room, active: active };
            }
            return room;
        });
        setRooms(updatedRooms);
    };

    const handleRegimensCheckboxChange = (regimenId: string, active: any) => {
        const updatedRegimen = regimens.map(regimen => {
            if (regimen.id === regimenId) {
                return { ...regimen, active: active };
            }
            return regimen;
        });
        setRegimens(updatedRegimen);
    };


    const closeDrawer = () => {
        setRegimens([]);
        setRooms([]);
        props.setHotelData(null)
        form.resetFields();
        props.setDrawerVisible(false);
    };

    const handleBtnCancel = () => {
        closeDrawer();
    };

    const normalizeCoordinate = (value: any) =>
        value === "" || value === undefined ? null : value;


    const onFinish = (values: any) => {
        setLoadingSaveButton(true)

        if (props.hotelData === null) { // CREATE
            const cate: Category = { type: values.typeCategory, number: values.numberCategory };
            const h: HotelsConfigCreateData = {
                name: values.name,
                category: cate,

                code: values.code,
                locationCode: values.locationCode,

                integrationCode: hotelIntegrationCode,
                locationIntegrationCode: locationIntegrationCode,

                destination: values.destination,
                countryCode: values.countryCode,
                countryName: values.countryName,
                longitude: normalizeCoordinate(values.longitude),
                latitude: normalizeCoordinate(values.latitude),

                numberRooms: values.numRooms,
                tax: values.tax,
                active: values.active,
                regimen: regimens.filter(r => r.active == true),
                rooms: rooms.filter(r => r.active == true),
                syncReward: values.sync,
                hotelPaxConfiguration: {
                    minAgeChild: values.minagechild ?? "",
                    maxAgeChild: values.maxagechild ?? "",
                    minAgeInfant: values.minageinfant ?? "",
                    maxAgeInfant: values.maxageinfant ?? "",
                    minAgeTeenager: values.minageteenager ?? "",
                    maxAgeTeenager: values.maxageteenager ?? ""
                },
                servicesSelected: selectedServiceIds
            };
            createHotelsConfig(h).then((response) => {
                if (response?.type == 1) {
                    closeDrawer();
                    setRegimens([]);
                    setRooms([]);
                }
                setLoadingSaveButton(false)
            });
        } else { // EDIT
            const categ: Category = { type: values.typeCategory, number: values.numberCategory };
            const h: HotelsConfigEditData = {
                id: props.hotelData.id,
                name: values.name,
                category: categ,

                code: values.code,
                locationCode: values.locationCode,

                integrationCode: hotelIntegrationCode,
                locationIntegrationCode: locationIntegrationCode,

                destination: values.destination,
                countryCode: values.countryCode,
                countryName: values.countryName,
                longitude: normalizeCoordinate(values.longitude),
                latitude: normalizeCoordinate(values.latitude),
                numberRooms: values.numRooms,
                active: values.active,
                regimen: regimens.filter(r => r.active == true),
                rooms: rooms.filter(r => r.active == true),
                syncReward: values.sync,
                hotelPaxConfiguration: {
                    minAgeChild: values.minagechild ?? props.hotelData.hotelPaxConfiguration?.minAgeChild ?? "",
                    maxAgeChild: values.maxagechild ?? props.hotelData.hotelPaxConfiguration?.maxAgeChild ?? "",
                    minAgeInfant: values.minageinfant ?? props.hotelData.hotelPaxConfiguration?.minAgeInfant ?? "",
                    maxAgeInfant: values.maxageinfant ?? props.hotelData.hotelPaxConfiguration?.maxAgeInfant ?? "",
                    minAgeTeenager: values.minageteenager ?? props.hotelData.hotelPaxConfiguration?.minAgeTeenager ?? "",
                    maxAgeTeenager: values.maxageteenager ?? props.hotelData.hotelPaxConfiguration?.maxAgeTeenager ?? ""
                },
                tax: values.tax,
                servicesSelected: selectedServiceIds

            }; console.log("el hotel pax es", h.hotelPaxConfiguration)


            editHotelsConfig(h).then((response) => {
                console.log(response)
                if (response?.type == 1) {
                    closeDrawer();
                    setRegimens([]);
                    setRooms([]);
                }
                setLoadingSaveButton(false)

            });
        }


    };

    const [selectedLanguage, setSelectedLanguage] = useState<string>();
    const setLanguage = (lang: string) => {
        setSelectedLanguage(lang);
    }


    const [isForcingCache, setIsForcingCache] = useState<boolean>(false);
    const forceRefreshCache = () => {
        if (props.onForceRefreshCache && props.hotelData?.integrationCode && props.hotelData?.integrationCode.length > 0) {
            props.onForceRefreshCache([props.hotelData?.integrationCode], selectedLanguage ?? props.language);
        }
    };

    useEffect(() => {
        setIsForcingCache(props.isForcingCache);
    }, [props.isForcingCache]);

    const mappingItems: TabsProps['items'] = [
        {
            key: '1',
            label: `${t("components.tab-mapping.title-pms")}`,
            children: <Row gutter={16}>
                <Col xs={24} md={12}>
                    <Form.Item
                        name="code"
                        label={t("components.tab-mapping.room-config.drawer.code-in-pms")}
                        initialValue={props.hotelData?.code}
                        rules={[
                            {
                                required: true,
                                message: t("components.tab-mapping.room-config.drawer.code-required") + ""
                            },
                        ]}

                    >
                        <Input className="app-input" />


                    </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                    <Form.Item
                        name="locationCode"
                        label={t("components.tab-mapping.hotels-config.drawer.location-code-in-pms")}
                        rules={[{ required: true, message: t("components.tab-mapping.hotels-config.drawer.locationCode-required") ?? "" }]}
                        initialValue={props.hotelData?.locationCode}
                    >

                        <Input className="app-input" />
                    </Form.Item>
                </Col>
                <Col xs={24}>
                    <small>
                        {t("components.tab-mapping.pms-codes-explanation")}
                    </small>
                </Col>
            </Row>,
        },
        {
            key: '2',
            label: `${t("components.tab-mapping.title-integrations")}`,
            children: <Row gutter={16}>
                <Col xs={24} md={12}>
                    <Form.Item
                        name="integrationCode"
                        label={t("components.tab-mapping.hotels-config.drawer.code-in-integrations")}
                        rules={[{ required: true, message: t("components.tab-mapping.hotels-config.drawer.code-required") ?? "Code is required" }]}
                    >
                        <Input className="app-input"
                            value={hotelIntegrationCode}
                            onChange={(e) => setHotelIntegrationCode(e.target.value)}
                        />

                    </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                    <Form.Item
                        name="locationIntegrationCode"
                        label={t("components.tab-mapping.hotels-config.drawer.location-code-in-integrations")}
                        rules={[{ required: true, message: t("components.tab-mapping.hotels-config.drawer.locationCode-required") ?? "" }]}

                    >

                        <Input
                            value={locationIntegrationCode}
                            onChange={(e) => setLocationIntegrationCode(e.target.value)}
                            className="app-input" />
                    </Form.Item>
                </Col>
                <Col xs={24}>
                    <small>
                        {t("components.tab-mapping.integration-codes-explanation")}
                    </small>
                </Col>
            </Row>,
        },
        {
            key: '3',
            label: `${t("components.tab-mapping.title-pax-configuration")}`,
            children: <Row gutter={16}>
                <Col xs={24} md={12}>
                    <Form.Item
                        name="minageinfant"
                        label={t("components.tab-mapping.min-age-infant")}
                        initialValue={props.hotelData?.hotelPaxConfiguration?.minAgeInfant ?? ""}
                    >
                        <Input className="app-input" />
                    </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                    <Form.Item
                        name="maxageinfant"
                        label={t("components.tab-mapping.max-age-infant")}
                        initialValue={props.hotelData?.hotelPaxConfiguration.maxAgeInfant ?? ""}
                    >

                        <Input className="app-input" />
                    </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                    <Form.Item
                        name="minagechild"
                        label={t("components.tab-mapping.min-age-child")}
                        initialValue={props.hotelData?.hotelPaxConfiguration?.minAgeChild == null ? "" : props.hotelData?.hotelPaxConfiguration?.minAgeChild}
                    >
                        <Input className="app-input" />
                    </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                    <Form.Item
                        name="maxagechild"
                        label={t("components.tab-mapping.max-age-child")}
                        initialValue={props.hotelData?.hotelPaxConfiguration?.maxAgeChild ?? ""}
                    >

                        <Input className="app-input" />
                    </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                    <Form.Item
                        name="minageteenager"
                        label={t("components.tab-mapping.min-age-teenager")}
                        initialValue={props.hotelData?.hotelPaxConfiguration?.minAgeTeenager ?? ""}
                    >
                        <Input className="app-input" />
                    </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                    <Form.Item
                        name="maxageteenager"
                        label={t("components.tab-mapping.max-age-teenager")}
                        initialValue={props.hotelData?.hotelPaxConfiguration?.maxAgeTeenager ?? ""}
                    >

                        <Input className="app-input" />
                    </Form.Item>
                </Col>


                <Col xs={24}>
                    <small>
                        {t("components.tab-mapping.pax-configuration-explanation")}
                    </small>
                </Col>
            </Row>
        },
        {
            key: '4',
            label: `${t("components.tab-mapping.cache")}`,
            children: <Row gutter={16}>
                <Col xs={24} className="btn-force-refresh-cache-container">
                    <Select
                        className="app-input select-language-cache"
                        defaultValue={"ES"}
                        onChange={setLanguage}
                    >
                        {
                            //Metemos el ISO de todos los idiomas disponibles
                        }
                        {
                            props.availableWALanguages.map(lang => (
                                <Select.Option key={lang} value={lang}>
                                    {lang}
                                </Select.Option>
                            ))
                        }
                    </Select>
                    <Button disabled={isForcingCache} loading={isForcingCache} className="app-button danger" onClick={forceRefreshCache}>
                        {t("components.tab-mapping.force-refresh-cache")}
                    </Button>
                </Col>
                <Col xs={24} className="force-refresh-cache-explanation-container">
                    <small>
                        {t("components.tab-mapping.cache-explanation")}
                    </small>
                </Col>
            </Row>
        }
    ];



    return (
        <div className='hotels-form-component'>
            {loading ? (
                <div className="loading-data">
                    <LoadingData />
                </div>
            ) : (
                <Form form={form} onFinish={onFinish} layout="vertical">
                    <Row gutter={16}>

                        <Col xs={24} md={24}>
                            <Form.Item
                                name="active"
                                label={t("components.tab-mapping.hotels-config.drawer.active")}
                                initialValue={props.hotelData?.active}
                                className="switch-container"
                            >
                                <Switch />
                            </Form.Item>
                        </Col>
                        <Divider>
                            {t("components.tab-mapping.hotels-config.drawer.title-basic-info")}
                        </Divider>
                        <Col xs={24} md={24}>
                            <Form.Item
                                name="name"
                                label={t("components.tab-mapping.hotels-config.drawer.name")}
                                rules={[{ required: true, message: t("components.tab-mapping.hotels-config.drawer.name-required") ?? "Name is required" }]}
                                initialValue={props.hotelData?.name}
                            >
                                <Input className="app-input" />
                            </Form.Item>
                        </Col>


                        <Col xs={24} md={24}>
                            <Form.Item
                                name="countryName"
                                label={t("components.tab-mapping.hotels-config.drawer.country-name")}
                                initialValue={props.hotelData?.countryName}
                                rules={[{ required: true, message: t("forms.validations.required-field") ?? "Country is required" }]}

                            >
                                <Input className="app-input" />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={24}>
                            <Form.Item
                                name="countryCode"
                                label={t("components.tab-mapping.hotels-config.drawer.country-code")}
                                initialValue={props.hotelData?.countryCode}
                                rules={[{ required: true, message: t("forms.validations.required-field") ?? "Destination is required" }]}
                            >
                                <Input className="app-input" />
                            </Form.Item>
                        </Col>

                        <Col xs={24} md={24}>
                            <Form.Item
                                name="destination"
                                label={t("components.tab-mapping.hotels-config.drawer.destination")}
                                rules={[{ required: true, message: t("components.tab-mapping.hotels-config.drawer.destination-required") ?? "Destination is required" }]}
                                initialValue={props.hotelData?.destination}
                            >
                                <Input className="app-input" />
                            </Form.Item>
                        </Col>


                        <Col xs={24} md={12}>
                            <Form.Item
                                name="latitude"
                                label={t("components.tab-mapping.hotels-config.drawer.latitude")}
                                rules={[

                                    {
                                        pattern: new RegExp(/^-?\d*(\.\d+)?$/),
                                        message: String(t("components.tab-mapping.hotels-config.drawer.number-required")), // Mensaje si el valor no es un número
                                    }
                                ]}
                                initialValue={props.hotelData?.latitude}
                            >

                                <Input className="app-input" step={0.01} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item
                                name="longitude"
                                label={t("components.tab-mapping.hotels-config.drawer.longitude")}
                                rules={[

                                    {
                                        pattern: new RegExp(/^-?\d*(\.\d+)?$/),
                                        message: String(t("components.tab-mapping.hotels-config.drawer.number-required")), // Mensaje si el valor no es un número
                                    }
                                ]}
                                initialValue={props.hotelData?.longitude}
                            >
                                <Input className="app-input" />
                            </Form.Item>
                        </Col>



                        <Col xs={24} md={24}>
                            <Form.Item
                                name="numRooms"
                                label={t("components.tab-mapping.hotels-config.drawer.room-number")}
                                rules={[{ required: true, message: t("components.tab-mapping.hotels-config.drawer.room-number-required") ?? "Room number is required" }]}
                                initialValue={props.hotelData?.numberRooms}
                            >
                                <InputNumber className="app-input" />
                            </Form.Item>
                        </Col>

                        <Col xs={12} md={12}>
                            <Form.Item
                                name="numberCategory"
                                label={t("components.tab-mapping.hotels-config.drawer.category")}
                                initialValue={props.hotelData?.category.number}
                                className="select-container"
                                rules={[{ required: true, message: "" }]}

                            >
                                <Select>
                                    {numberCategory.map((value) => (
                                        <Select.Option key={value} value={value}>
                                            {value}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col xs={12} md={12}>
                            <Form.Item
                                name="typeCategory"
                                label=" "
                                initialValue={props.hotelData?.category.type || 'star'}
                                className="select-container"
                            >
                                <Select>
                                    {typeCategory.map((category) => (
                                        <Select.Option key={category.key} value={category.key}>
                                            {category.icon}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        <Col xs={12} md={12}>
                            <Form.Item
                                name="tax"
                                label={t("components.tab-mapping.hotels-config.drawer.taxs")}
                                initialValue={0}
                            >
                                <InputNumber
                                    className="app-input"
                                    step={0.01}
                                    precision={2}
                                    min={0}
                                    max={100}
                                    suffix={"%"}
                                />

                            </Form.Item>
                        </Col>
                        <Col xs={24} md={24}>
                            <Form.Item
                                name="services"
                                label={t("components.tab-mapping.room-config.drawer.services")}
                            > {
                                    <IconSelectorMultiple
                                        onChange={(ids: any) => setSelectedServiceIds(ids)}
                                        value={selectedServiceIds}
                                        optionsSelector={optionsSelector}
                                        servicesAvailable={servicesAvailable}  // 👈 añadimos esto
                                    />
                                }

                            </Form.Item>
                        </Col>


                        <Divider>
                            {t("components.tab-mapping.title-mapping-code")}
                        </Divider>
                        <Col xs={24} md={24}>
                            <Tabs defaultActiveKey="1" items={mappingItems} />
                        </Col>

                        <Divider>
                            {t("components.tab-mapping.hotels-config.drawer.title-configuration")}
                        </Divider>

                        <Col xs={12} md={12}>
                            <Form.Item label={t("components.tab-mapping.hotels-config.drawer.rooms")}>
                                <Input
                                    placeholder={t("button.search") || "Buscar habitación"}
                                    allowClear
                                    className="app-input"
                                    onChange={e => setRoomSearch(e.target.value)}
                                    style={{ marginBottom: 8 }}
                                />

                                <div className="multiple-checks-container scrollable">
                                    {filteredRooms.map(room => (
                                        <Checkbox
                                            key={room.id}
                                            checked={room.active}
                                            className="notBold"
                                            onChange={e =>
                                                handleRoomsCheckboxChange(room.id, e.target.checked)
                                            }
                                        >
                                            {room.name} ({room.pmsCode})
                                        </Checkbox>
                                    ))}
                                </div>
                            </Form.Item>

                        </Col>


                        <Col xs={12} md={12}>
                            <Form.Item label={t("components.tab-mapping.hotels-config.drawer.regimes")}>
                                <Input
                                    placeholder={t("button.search") || "Buscar régimen"}
                                    allowClear
                                    className="app-input input"
                                    onChange={e => setRegimenSearch(e.target.value)}
                                    style={{ marginBottom: 8 }}
                                />

                                <div className="multiple-checks-container scrollable">
                                    {filteredRegimens.map(regimen => (
                                        <Checkbox
                                            key={regimen.id}
                                            checked={regimen.active}
                                            className="notBold"
                                            onChange={e =>
                                                handleRegimensCheckboxChange(regimen.id, e.target.checked)
                                            }
                                        >
                                            {regimen.name} ({regimen.pmsCode})
                                        </Checkbox>
                                    ))}
                                </div>
                            </Form.Item>

                        </Col>

                        <Col xs={24} md={12}>
                            <Form.Item className="button-container">
                                <Button className="app-white-button width-95" onClick={handleBtnCancel}>
                                    {t("components.button.cancel")}
                                </Button>
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={12}>
                            <Form.Item className="button-container">
                                <Button className="app-button width-95"
                                    disabled={loadingSaveButton || hotelIntegrationCode?.length === 0 || locationIntegrationCode?.length === 0}
                                    htmlType="submit"
                                    loading={loadingSaveButton}>
                                    {t("components.button.save")}
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            )}
        </div>
    );
};


export default HotelForm;